import React, { Component } from 'react';
import moment from 'moment';
import { Row, Col, Card, CardBody, Input } from 'reactstrap';

import DateFilter from '../../components/ParadigmaTable/DateFilter';
import ModalVentas from "../Ventas/Modal";
import NumericFilter from '../../components/ParadigmaTable/NumericFilter';
import ParadigmaDatePicker from '../../components/ParadigmaDatePicker/ParadigmaDatePicker';
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaTable from "../../components/ParadigmaTable/ParadigmaTable.js";
import api from "../../api/api.js";
import apiFunctions from "../../api/functions.js";
import { format } from '../../functions/functions';

class CuotasPagas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totales:{
                totalMontoPesos: null,
                totalPagoPesos: null,
                totalInteresPesos: null,
                totalMontoDolares: null,
                totalPagoDolares: null,
                totalInteresDolares: null,
            },
            monedaPesos: null,
            monedaDolares: null,
            filtros:[],
            outerSort: [{
                id: 'fechaPago',
                desc: true
            }],
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Moneda",
                    id: "moneda",
                    filterable: false,
                    show: false,
                    private: true,
                },
                {
                    Header: "Comprador/es",
                    id: "clientes",
                    accessor: d => d.clientes,
                    show: true,
                    Filter: ({ filter, onChange }) => <Input value={(filter) ? (filter.value) : ''} onChange={(e)=>{this.agregarFiltros('clientes', e.target.value); onChange(e.target.value);}} />,
                    exportWidth: '10%',
                },
                {
                    Header: "N° Cuota",
                    id: "nroCuota",
                    accessor: d => d.esEspecial ? 'E' : d.nroCuota,
                    className: "text-right",
                    show: true,
                    width: 50,
                    Filter: ({ filter, onChange }) => <Input value={(filter) ? (filter.value) : ''} onChange={(e)=>{this.agregarFiltros('nroCuota', e.target.value); onChange(e.target.value);}} />,
                    exportWidth: '5%',
                },
                {
                    Header: "Total Cuotas",
                    id: "totalCuotas",
                    accessor: "totalCuotas",
                    className: "text-right",
                    show: true,
                    width: 50,
                    Filter: ({ filter, onChange }) => <Input value={(filter) ? (filter.value) : ''} onChange={(e)=>{this.agregarFiltros('totalCuotas', e.target.value); onChange(e.target.value);}} />,
                    exportWidth: '5%',
                },
                {
                    Header: "Lote",
                    id: "lote_nombre",
                    accessor: d => d.lote_nombre,
                    className: "text-center",
                    show: true,
                    Filter: ({ filter, onChange }) => <Input value={(filter) ? (filter.value) : ''} onChange={(e)=>{this.agregarFiltros('lote_nombre', e.target.value); onChange(e.target.value);}} />,
                    exportWidth: '7%',
                },
                {
                    Header: "Monto",
                    id: "monto",
                    className: "text-right",
                    accessor: d => `${d.moneda.simbolo} ${format(d.monto)}`,
                    show: true,
                    Filter: ({ filter, onChange }) => <NumericFilter filter={filter} onChange={(e)=>{this.agregarFiltros('monto', e); onChange(e);}} />,
                    exportWidth:'9%',
                    exportCurrency: true,
                },
                {
                    Header: "Interés",
                    id: "interes",
                    className: "text-right",
                    accessor: d => `${d.moneda.simbolo} ${format(d.interes)}`,
                    show: true,
                    Filter: ({ filter, onChange }) => <NumericFilter filter={filter} onChange={(e) => {this.agregarFiltros('interes', e); onChange(e);}} />,
                    exportWidth: '9%',
                    exportCurrency: true,
                },
                {
                    Header: "Fecha Cobro",
                    id: "fechaPago",
                    accessor: d => d.fechaPago ? moment(d.fechaPago).format('DD/MM/YYYY') : '-',
                    className: "text-center",
                    show: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={(e)=>{this.agregarFiltros('fechaPago', e); onChange(e);}} />,
                    exportWidth: '9%',
                },
                {
                    Header: "Vencimiento",
                    id: "vencimiento",
                    className: "text-center",
                    accessor: d => moment(d.vencimiento).format('DD/MM/YYYY'),
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={(e)=>{this.agregarFiltros('vencimiento', e); onChange(e);}} />,
                    show: true,
                    exportWidth: '10%',
                },
                {
                    Header: "Loteo",
                    id: "loteo",
                    accessor: d => d.loteo,
                    show: true,
                    Filter: ({ filter, onChange }) => <Input value={(filter) ? (filter.value) : ''} onChange={(e)=>{this.agregarFiltros('loteo', e.target.value); onChange(e.target.value);}} />,
                    exportWidth: '11%',
                },
                {
                    Header: "Vendedor",
                    id: "vendedor_nombre",
                    accessor: d => d.vendedor_nombre,
                    show: true,
                    Filter: ({ filter, onChange }) => <Input value={(filter) ? (filter.value) : ''} onChange={(e)=>{this.agregarFiltros('vendedor_nombre', e.target.value); onChange(e.target.value);}} />,
                    exportWidth: '13%',
                },
                {
                    Header: "Usuario",
                    id: "nomAutor",
                    accessor: d => d.nomAutor,
                    show: true,
                    Filter: ({ filter, onChange }) => <Input value={(filter) ? (filter.value.trimStart()) : ''} onChange={(e)=>{this.agregarFiltros('nomAutor', e.target.value); onChange(e.target.value);}} />,
                    exportWidth: '12%',
                },
                {
                    Header: "ventaId",
                    id: "ventaId",
                    accessor: d => d.vendedor_nombre,
                    show: false,
                    private: true,
                },
            ],
            fechaDesde: '',
            fechaHasta: '',
        };
    }

    componentDidMount = () => {
        // this.capturarTotal();
    }

    capturarTotal = () => {
        const { fechaDesde, fechaHasta} = this.state;
        let filtros = [...this.state.filtros];
        if (fechaDesde) {
            filtros.push({
                id: 'fecha_desde',
                value: moment(fechaDesde).format('YYYY/MM/DD')
            });
        }
        if (fechaHasta) {
            filtros.push({
                id: 'fecha_hasta',
                value: moment(fechaHasta).format('YYYY/MM/DD'),
            });
        }

        let parameters = {};

        let filters = filtros.map(filter => {
			const data = filter.value;
			if (typeof data === "object") {
				return `${filter.id}[${data.lookup}]=${data.input}`;
			} else if (!data) { // en caso en que no se envíen datos en el filtro, se resetea
				return;
			} else {
				return filter.id + "[icontains]=" + data;
			}
		}).filter(filter => !!filter); // filtra los vacíos
        if (filters.length > 0) parameters.filters = filters;
        
        apiFunctions.get(api.ventas.listCuotasTotal, null, null, parameters, (e) => {
            const data = e.data;

            this.setState({
                totales: {
                    totalMontoPesos: data.totalMontoPesos,
                    totalPagoPesos: data.totalPagoPesos,
                    totalInteresPesos: data.totalInteresPesos,
                    totalMontoDolares: data.totalMontoDolares,
                    totalPagoDolares: data.totalPagoDolares,
                    totalInteresDolares: data.totalInteresDolares,
                },
                monedaPesos: data.moneda_pesos,
                monedaDolares: data.moneda_dolares,
            })
        }); 
    }

    agregarFiltros = async (id, value) => {
        let filtro = [...this.state.filtros];
        let encontre = false;
        
        if(id=='nomAutor'){
            if(value.length>1){
                value = value.trimStart();
            }
        }

        for (let i=0; i<=filtro.length-1; i++){
            if(filtro[i].id==id){
                if(value==''){
                    filtro.splice(i,1);
                }else{
                    filtro[i].value=value;
                }
                encontre = true;
                break;
            }
        } 
        if(!encontre){
            filtro.push({id:id, value:value});
        }
        await this.setState({filtros: filtro});
        this.capturarTotal();
    }

    render() {
        const { 
            fechaDesde,
            fechaHasta,
            filtros,
            totales,
            monedaPesos,
            monedaDolares,
        } = this.state;

        let outerFilter = [];
        if (fechaDesde) {
            outerFilter.push({
                id: 'fecha_desde',
                value: moment(fechaDesde).format('YYYY/MM/DD')
            });
        }
        if (fechaHasta) {
            outerFilter.push({
                id: 'fecha_hasta',
                value: moment(fechaHasta).format('YYYY/MM/DD'),
            });
        }

        if(filtros['nomAutor']==undefined){
            outerFilter.push({
                id: 'nomAutor',
                value: ' ',
            });
        }

        return (
            <Row className="m-0 cont-cuotas-pagas">
                {<Col className="col-12 mt-2">
                    <Card body className="border-0 p-0 mb-3">
                        <CardBody>
                            <Row>
                                <Col className="col-5 col-md-4 col-lg-3 mr-5">
                                    <ParadigmaLabeledInput
                                        lg={[5, 7]}
                                        md={[6, 6]}
                                        label={"Fecha Desde"}
                                        inputComponent={
                                            <div className={"date-filterFDH has-valueFDH"}>
                                                <ParadigmaDatePicker
                                                    value={moment(this.state.fechaDesde).format('DD/MM/YYYY')}
                                                    onChange={e => {this.setState({ fechaDesde: e }); setTimeout(()=> this.capturarTotal(), 50); }}
                                                    error={() => this.getError('fechaDesde')}
                                                />
                                                <div className="date-filterFDH__buttons">
                                                    <button
                                                        className="date-filterFDH__button date-filterFDH__button-close"
                                                        onClick={(e) => {this.setState({ fechaDesde: '' }); setTimeout(()=> this.capturarTotal(), 50);}}
                                                    >
                                                        <i className={'fa fa-times'}></i>
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    />
                                </Col>

                                <Col className="col-5 col-md-4 col-lg-3 ">
                                    <ParadigmaLabeledInput
                                        lg={[5, 7]}
                                        md={[6, 6]}
                                        label={"Fecha Hasta"}
                                        inputComponent={
                                            <div className={"date-filterFDH has-valueFDH"}>
                                                <ParadigmaDatePicker
                                                    value={moment(this.state.fechaHasta).format('DD/MM/YYYY')}
                                                    onChange={e => {this.setState({ fechaHasta: e }); setTimeout(()=> this.capturarTotal(), 50);}}
                                                    error={() => this.getError('fechaHasta')}
                                                />
                                                <div className="date-filterFDH__buttons">
                                                    <button
                                                        className="date-filterFDH__button date-filterFDH__button-close"
                                                        onClick={(e) => {this.setState({ fechaHasta: '' }); setTimeout(()=> this.capturarTotal(), 50);}}
                                                    >
                                                        <i className={'fa fa-times'}></i>
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>}

                <Col className="col-12 tab-cobros-cuotas">
                    <ParadigmaTable
                        buttons={[{
                                    edit: true,
                                    component: props => <ModalVentas idV={(props.row()) ? (props.row().ventaId) : (null)} {...props} action="CUOTAS" activeTab={2} />,
                                    permission: 'ventas_ventas_view',
                                }]}
                        defaultPageSize={15}
                        depth={1}
                        apiUrl={api.ventas.listCuotas}
                        columns={this.state.columns}
                        exportUrl={api.ventas.listCuotas}
                        title={"Cobros Cuotas"}
                        outerSort={this.state.outerSort}
                        outerFilter={[...outerFilter,]}
                    />
                </Col>

                
                {<Col className="col-12 mt-4">
                    <Card body className="border-0 p-0 mb-2">

                        <CardBody className='pt-2 pb-2'>
                            <Row>
                                <Col className="col-12 col-sm-6 col-md-4 col-lg-3">
                                    <ParadigmaLabeledInput
                                        label={"Total Monto"}
                                        classNames={['pr-0','monto']}
                                        value={ totales.totalMontoPesos 
                                            ? `${monedaPesos.simbolo} ${format(totales.totalMontoPesos.toString())}`
                                            : '-'
                                        }
                                    />
                                </Col>

                                <Col className="col-12 col-sm-6 col-md-4 col-lg-3">
                                    <ParadigmaLabeledInput
                                        label={"Total Interes"}
                                        classNames={['pr-0','monto']}
                                        value={ totales.totalInteresPesos 
                                            ? `${monedaPesos.simbolo} ${format(totales.totalInteresPesos.toString())}`
                                            : '-'
                                        }
                                    />
                                </Col>
                                
                                <Col className="col-12 col-sm-6 col-md-4 col-lg-3">
                                    <ParadigmaLabeledInput
                                        label={"Total Cobrado"}
                                        classNames={['pr-0','monto']}
                                        value={ totales.totalPagoPesos 
                                            ? `${monedaPesos.simbolo} ${format(totales.totalPagoPesos.toString())}`
                                            : '-'
                                        }
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col className="col-12 col-sm-6 col-md-4 col-lg-3">
                                    <ParadigmaLabeledInput
                                        label={"Total Monto"}
                                        classNames={['pr-0','monto']}
                                        value={ totales.totalMontoDolares 
                                            ? `${monedaDolares.simbolo} ${format(totales.totalMontoDolares.toString())}`
                                            : '-'
                                        }
                                    />
                                </Col>

                                <Col className="col-12 col-sm-6 col-md-4 col-lg-3">
                                    <ParadigmaLabeledInput
                                        label={"Total Interes"}
                                        classNames={['pr-0','monto']}
                                        value={ totales.totalInteresDolares 
                                            ? `${monedaDolares.simbolo} ${format(totales.totalInteresDolares.toString())}`
                                            : '-'
                                        }
                                    />
                                </Col>
                                
                                <Col className="col-12 col-sm-6 col-md-4 col-lg-3">
                                    <ParadigmaLabeledInput
                                        label={"Total Cobrado"}
                                        classNames={['pr-0','monto']}
                                        value={ totales.totalPagoDolares 
                                            ? `${monedaDolares.simbolo} ${format(totales.totalPagoDolares.toString())}`
                                            : '-'
                                        }
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>}

            </Row>
        );
    }
}

export default CuotasPagas;



// WEBPACK FOOTER //
// ./src/views/CuotasPagas/CuotasPagas.js